
import vehicleFile from './vehicleFile'



// 定制逻辑处理
export default {
  ...vehicleFile,
}
